import { atom, selector } from 'recoil';
import { getMetadata } from 'repositories/HttpRepository';

export const selectedDps = atom({
  key: 'dsp_selected_dsp',
  default: { company: null },
});

export const dspState = atom({
  key: 'dsp_list',
  default: false,
});

export const getSelectorPlatform = selector({
  key: 'selector/platform',
  get: async () => {
    const response = await getMetadata('AP_DATAORCH', 'APP_CONFIG');
    return response.data;
  },
});
